<template>
<div>
    <v-card>
        <v-toolbar dark flat color="primary">
            <v-toolbar-title>Edit class</v-toolbar-title>
        </v-toolbar>

        <div v-if="laravelErrors.active" class="text-xs-center">
            <v-chip v-for="(msg,key) in laravelErrors.messages" :key="key" label color="red" text-color="white">{{ msg[0] }}
            </v-chip>
        </div>

        <v-card-text>
            <v-form overflow>
                <v-layout row wrap>
                    <v-flex xs6 px-2>
                        <v-text-field v-model="course.section" label="Section" name="section" v-validate="'required'">
                        </v-text-field>
                        <span class="error--text">{{ errors.first('section') }}</span>
                    </v-flex>
                    <v-flex xs6 px-2>
                        <v-text-field v-model="course.name" label="Name" name="name" v-validate="'required'">
                        </v-text-field>
                        <span class="error--text">{{ errors.first('name') }}</span>
                    </v-flex>
                    <v-flex xs12 px-2 mb-4>
                        <label class="v-label theme--light">Description</label>
                        <editor api-key="7gqau1f4duzeamdn8huh87swpqmf12n8p7i58lplclxzj12p" :init="{ plugins: 'textcolor colorpicker emoticons link', toolbar: 'forecolor emoticons link', height: '300' }" v-model="course.description" v-validate="'required'" name="description">
                        </editor>
                        <span class="error--text pl-2">{{ errors.first('description') }}</span>
                    </v-flex>
                    <v-flex xs3 px-2>
                        <v-text-field v-model="course.max_seats" label="Max Seats" name="max_seats" v-validate="'required'">
                        </v-text-field>
                        <span class="error--text">{{ errors.first('max_seats') }}</span>
                    </v-flex>
                    <v-flex xs3 px-2>
                        <v-text-field v-model="course.room" name="room" label="Room">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs3 px-2>
                        <v-select :items="['All Day', '1', '2', '3', '4', '5', '6', '7', '8', 'Optional']" v-model="course.period" name="period" label="Period" v-validate="'required'">
                        </v-select>
                        <span class="error--text">{{ errors.first('period') }}</span>
                    </v-flex>
                    <v-flex xs3 px-2>
                        <v-select :items="daysArray" label="Day" name="day" v-model="course.days" v-validate="'required'">
                        </v-select>
                        <span class="error--text">{{ errors.first('day') }}</span>
                    </v-flex>
                    <v-flex xs4 px-2>
                        <v-text-field name="time" label="Time" v-model="course.time" v-validate="'required'">
                        </v-text-field>
                        <span class="error--text">{{ errors.first('time') }}</span>
                    </v-flex>
                    <v-flex xs4 px-2>
                        <v-autocomplete :items="teachers" :item-text="teacherDisplay" v-model="course.teacher" label="Teacher" name="teacher" search-input return-object>
                        </v-autocomplete>
                        <span class="error--text">{{ errors.first('teacher') }}</span>
                    </v-flex>
                    <v-flex xs4 px-2>
                        <v-select :items="semesters" item-value="name" item-text="name" v-model="course.semester" name="semester" label="Semester" v-validate="'required'">
                        </v-select>
                        <span class="error--text">{{ errors.first('semester') }}</span>
                    </v-flex>
                    <v-flex xs12 px-2 my-3>
                        <v-text-field label="Section Restrictions" name="restrictions" v-model="course.restrictions" v-validate="{regex: /^([0-9]{2,4})(,[0-9]{2,4})*$/}">
                        </v-text-field>
                        <span class="error--text">{{ errors.first('restrictions') }}</span>
                    </v-flex>
                    <v-flex xs12 px-2 my-3>
                        <h4 class="subheader">Grades</h4>
                        <v-checkbox class="px-3 d-inline-block" value="K" label="K" name="grade" v-model="course.grade" v-validate="'required'"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="1" label="1" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="2" label="2" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="3" label="3" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="4" label="4" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="5" label="5" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="6" label="6" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="7" label="7" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="8" label="8" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="9" label="9" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="10" label="10" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="11" label="11" name="grade" v-model="course.grade"></v-checkbox>
                        <v-checkbox class="px-3 d-inline-block" value="12" label="12" name="grade" v-model="course.grade"></v-checkbox>
                        <div class="error--text">{{ errors.first('grade') }}</div>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue white--text" @click.native="save">Save</v-btn>
        </v-card-actions>

    </v-card>

    <v-dialog v-model="addedAlert" max-width="500px">
        <v-card>
            <v-card-text>
                <v-alert :value="true" type="success">Class successfully updated!</v-alert>
            </v-card-text>
            <v-card-actions>
                <v-btn flat color="primary" @click.stop="addedAlert = false">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'

export default {
    props: ['course'],
    components: {
        editor: Editor
    },
    data() {
        return {
            daysArray: [{
                    text: 'Mon',
                    value: 'M'
                },
                {
                    text: 'Tue/Thu',
                    value: 'T/TH'
                },
                {
                    text: 'Wed',
                    value: 'W'
                },
                {
                    text: 'Fri',
                    value: 'F'
                }
            ],
            successMsg: false,
            addedAlert: false
        }
    },
    computed: {
        teachers() {
            return this.$store.state.admin.teachers
        },
        semesters() {
            return this.$store.state.semesterModule.semesters
        },
        laravelErrors() {
            return this.$store.state.errorModule.validation
        }
    },
    created() {
        this.errors.clear()
        this.$store.commit('clearErrors')
    },
    methods: {
        save() {
            this.$store.commit('clearErrors')

            this.$validator.validateAll().then((result) => {
                if (result) {
                    let payload = {
                        id: this.course.id,
                        teacher_id: this.course.teacher.id,
                        section: this.course.section,
                        name: this.course.name,
                        description: this.course.description,
                        grade: this.course.grade.join(','),
                        max_seats: this.course.max_seats,
                        room: this.course.room,
                        period: this.course.period,
                        days: this.course.days,
                        time: this.course.time,
                        restrictions: this.course.restrictions,
                        semester: this.course.semester
                    }
                    this.$store.dispatch('editCourseDetails', payload)
                        .then(() => {
                            this.addedAlert = true
                        })
                        .catch(() => {})
                }
            })
        },
        teacherDisplay: item => item.first_name + ' ' + item.last_name
    }
}
</script>
